import { createContext } from 'react';

interface ZendeskWidgetContextType {
  isLoading: boolean;
  isOpen: boolean;
  openChat: () => void;
  unreadCount: number;
}

export const ZendeskWidgetContext = createContext<ZendeskWidgetContextType>({
  isLoading: false,
  isOpen: false,
  openChat: () => {},
  unreadCount: 0,
});
